<template>
  <div class="enrolling-exam-write-fail-student">
    <PlatDataGridSiteUnit grid-id="PeEnrollExamWriteFailStudent"
                          show-label></PlatDataGridSiteUnit>
  </div>
</template>

<script>
import PlatDataGridSiteUnit from '../../../../../wrapper/grid/PlatDataGridSiteUnit'
export default {
  name: 'EnrollingExamWriteFailStudent',
  components: {
    PlatDataGridSiteUnit
  }
}
</script>

<style lang="scss">
  .enrolling-exam-write-fail-student {
    height: 100%;
  }
</style>
